import { registerFeature, registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_ASSET_MAPPING = registerFeature({
    numericalId: 2,
    name: "Asset Mapping",
    id: "assets",
    description: `Asset registers and asset mapping features in Regime.`,
    readyForProduction: true,
})

export const FEATURE_FLAG_ADVANCED_REGIME_TABS = registerFeature({
    numericalId: 2500,
    name: "Advanced Regime Tabs",
    id: "advanced-regime-tabs",
    description: `Additional tabs for maintenance regimes.`,
    readyForProduction: true,
})

export const FEATURE_FLAG_ASSET_MAPPING_VARIATION_FROM_LIBRARY = registerFeatureWithDescription({
    numericalId: 2500.1,
    id: "asset-mapping-variation-from-library",
    name: "Regimes > Variation From Library Tab",
    readyForProduction: true,
    descriptionLines: ["Enables 'Variation from Library' tab in the review mode of a maintenance regime"],
})

export const FEATURE_FLAG_ASSET_MAPPING_SCHEDULE_LIBRARY_UPDATES = registerFeatureWithDescription({
    numericalId: 2500.2,
    id: "asset-mapping-schedule-library-updates",
    name: "Regimes > Schedule Library Updates Tab",
    readyForProduction: true,
    descriptionLines: ["Enables 'Schedule Library Updates' tab  when viewing a maintenance regime"],
})

export const FEATURE_FLAG_ASSET_MAPPING_OVERVIEW = registerFeatureWithDescription({
    numericalId: 2500.3,
    id: "asset-mapping-overview",
    name: "Regimes > Overview Tab",
    readyForProduction: true,
    descriptionLines: ["Enables 'Overview' tab when viewing a maintenance regime"],
})

export const FEATURE_FLAG_ASSET_MAPPING_TAILORED = registerFeatureWithDescription({
    numericalId: 2500.4,
    id: "asset-mapping-tailored",
    name: "Regimes > Tailored Tab",
    readyForProduction: true,
    descriptionLines: ["Enables 'Tailored' tab when viewing a maintenance regime"],
})

// WIN-1706 make tasks tab unavailable to configure but available for devs.
// export const FEATURE_FLAG_ASSET_MAPPING_TASK_MANAGEMENT = registerFeatureWithDescription({
//     numericalId: 2.4,
//     id: "asset-mapping-tasks",
//     name: "Regimes > Tasks Tab",
//     descriptionLines: ["Enables the 'Tasks' tab when viewing a maintenance regime"],
// })
